"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>Maps_GoogleMapComponents
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const external_useGoogleMapsHooks_js_namespaceObject = require("./useGoogleMapsHooks.js");
const useChatUIContext_js_namespaceObject = require("../../hooks/useChatUIContext.js");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const MetadataManager_js_namespaceObject = require("../MarkdownComponent/MetadataManager.js");
const RelativeBox = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "GoogleMapComponents__RelativeBox"
})([
    "position:relative;z-index:1000;"
]);
const CloseMapButton = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Button).withConfig({
    displayName: "GoogleMapComponents__CloseMapButton"
})([
    "position:absolute;top:16px;right:16px;"
]);
const GoogleMapComponents = /*#__PURE__*/ external_react_default().memo(({ mapContainerStyle = {
    height: 'calc(100% - 60px)',
    width: '100%'
}, buttonStyle = {
    position: 'absolute',
    bottom: '0',
    left: '50%',
    transform: 'translate(-50%, -15px)'
} })=>{
    const hotelOnMapList = MetadataManager_js_namespaceObject.inlineMetadataManager.getHotelOnMapList();
    const locationPinList = MetadataManager_js_namespaceObject.inlineMetadataManager.getLocationPinList();
    const { setIsMapOpened, isMapOpened, shouldDisplayMapButton } = (0, useChatUIContext_js_namespaceObject.useChatUIContext)();
    const hotelPinsOnMap = (0, external_react_namespaceObject.useMemo)(()=>hotelOnMapList?.reduce((acc, curr)=>{
            if (curr?.hotel?.hotelType !== 'SOPQ') acc[curr.name] = {
                ...curr
            };
            return acc;
        }, {}), [
        hotelOnMapList
    ]);
    const locationPinsOnMap = locationPinList.filter((pin)=>{
        if (pin?.hotelId) {
            const hasDuplicatePin = hotelOnMapList.some((hotel)=>hotel?.hotel?.hotelId === pin.hotelId);
            return !hasDuplicatePin;
        }
        return true;
    })?.reduce((acc, curr)=>{
        acc[curr.name] = {
            ...curr
        };
        return acc;
    }, {});
    (0, external_useGoogleMapsHooks_js_namespaceObject.useGoogleMapsHooks)({
        hotelPinsOnMap,
        locationPinsOnMap
    });
    const handleOnClick = (0, external_react_namespaceObject.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        setIsMapOpened(false);
    }, [
        setIsMapOpened
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_react_default().Fragment, {
        children: [
            isMapOpened && shouldDisplayMapButton && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RelativeBox, {
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(CloseMapButton, {
                    title: "Close Map",
                    variation: "white",
                    color: "primary",
                    size: "small",
                    onClick: handleOnClick,
                    children: "Close Map"
                })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                style: mapContainerStyle,
                id: "PENNY-SEARCH-GOOGLE-MAP"
            }),
            shouldDisplayMapButton && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                size: "small",
                style: buttonStyle,
                onClick: handleOnClick,
                title: "Close Map",
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Flex, {
                    children: [
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.ChatBubble, {
                            color: "lightest",
                            size: 16
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                            ml: 1,
                            children: "Chat"
                        })
                    ]
                })
            })
        ]
    });
});
GoogleMapComponents.displayName = 'GoogleMapComponents';
const Maps_GoogleMapComponents = GoogleMapComponents;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
